<script>
  import ChatContent from '@/components/ChatMsg/ChatContent.vue';
  export default {
    components: { ChatContent },
    props: {
      type: String,
      colorClass: String,
      data: Object
    },
  }
</script>
<template>
  <li class="line-item" :class="colorClass">
    <div class="lint-item__left">
      <div class="lint-item__info" v-if="data.contact">
        <el-image class="lint-item__avatar" :src="data.contact.avatar" :preview-src-list="[data.contact.avatar]">
          <div slot="error" style="text-align: center">
            <i class="el-icon-user fs46"></i>
          </div>
        </el-image>
        <div class="ml8 fs13 lh20">
          <div class="u-noWrapWithEllipsis" :title="data.contact.name">{{ data.contact.name }}</div>
          <div class="fs12">{{ data.contact.unionid }}</div>
        </div>
      </div>
    </div>
    <div class="line-item__right">
      <div class="lint-item__tail"></div>
      <div :class="[
        'lint-item__node',
        type === 'time' ? 'lint-item__node--circle' : 'lint-item__node--normal'
      ]"></div>
      <div class="lint-item__wrapper--circle" v-if="type === 'time'">
        <span>服务开通</span>
        <span class="ml15" v-if="data.msgDetail">{{ data.msgDetail.msgDataTime }}</span>
      </div>
      <div class="lint-item__wrapper" v-else>
        <el-image class="lint-item__avatar w50 h50" :src="data.employee ? data.employee.avatar : ''" :preview-src-list="[data.employee.avatar]">
          <div slot="error" style="text-align: center">
            <i class="el-icon-user fs50"></i>
          </div>
        </el-image>
        <div class="lint-item__wrapper__content" v-if="data.msgDetail">
          <div>
            <span>{{ data.msgDetail.name }} - {{ data.corpName }}</span>
            <span class="ml10" v-if="data.employee">{{ data.employee.wxUserId }}</span>
          </div>
          <div class="lint-item__small__text">
            <span>{{ data.msgDetail.msgDataTime }}</span>
            <span class="ml15">{{ data.msgDetail.msgId }}</span>
          </div>
          <div class="lint-item__msg">
            <ChatContent :data="data.msgDetail"/>
          </div>
          <slot name="wrapEnd"></slot>
        </div>
      </div>
    </div>
  </li>
</template>